<div class="panel iper-panel">
    <div class="panel-content iper-content">
        <p class="iper-banner">
            <i class="fa fa-copy"></i>
            Dati della pratica in sola lettura: clicca sull'icona accanto a ciascun valore per copiarlo. I campi vuoti non hanno un dato corrispondente nella pratica.
        </p>

        <!-- Punto 1 -->
        <section class="iper-section">
            <div class="iper-grid">
                <div class="iper-field">
                    <label class="iper-label">Ragione Sociale/Denominazione</label>
                    <app-copy-field [value]="companyName"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Partita IVA</label>
                    <app-copy-field [value]="vatNumber"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Partita IVA <i class="fa fa-info-circle iper-info"></i></label>
                    <app-copy-field [value]="vatNumber"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Forma giuridica</label>
                    <app-copy-field [value]="customer?.LegalForm"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">PEC</label>
                    <app-copy-field [value]="customer?.PEC"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>Codice ATECO <i class="fa fa-info-circle iper-info"></i></label>
                    <app-copy-field [value]="atecoCode"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>Dimensione impresa</label>
                    <app-copy-field [value]="companySize"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Impresa di nuova costituzione</label>
                    <app-copy-field></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>Società obbligata alla revisione legale dei conti</label>
                    <app-copy-field [value]="statutoryAudit"></app-copy-field>
                </div>
                <div class="iper-field iper-field-spacer"></div>
                <div class="iper-field">
                    <label class="iper-label">Data iscrizione al registro delle imprese</label>
                    <app-copy-field [value]="date(customer?.RegistrationDate)"></app-copy-field>
                    <p class="iper-note">{{ registrationHint }}</p>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Data costituzione</label>
                    <app-copy-field></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Appartenenza ad un gruppo di imprese:</label>
                    <app-copy-field [value]="groupMembership"></app-copy-field>
                </div>
            </div>

            <h4 class="iper-subtitle">Referente da contattare</h4>
            <div class="iper-grid">
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>Nome</label>
                    <app-copy-field [value]="customer?.Name"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>Cognome</label>
                    <app-copy-field [value]="customer?.Surname"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Telefono</label>
                    <app-copy-field [value]="customer?.Phone"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>Email</label>
                    <app-copy-field [value]="customerEmail"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>Cellulare <i class="fa fa-info-circle iper-info"></i></label>
                    <app-copy-field [value]="customer?.MobilePhone"></app-copy-field>
                </div>
            </div>

            <h4 class="iper-subtitle">Sede legale</h4>
            <div class="iper-grid">
                <div class="iper-field">
                    <label class="iper-label">Nazione</label>
                    <app-copy-field [value]="country"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Città</label>
                    <app-copy-field [value]="legalCity"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Indirizzo</label>
                    <app-copy-field [value]="customer?.Address"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Civico</label>
                    <app-copy-field [value]="customer?.HouseNumber"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">CAP</label>
                    <app-copy-field></app-copy-field>
                </div>
            </div>

            <h4 class="iper-subtitle">Rappresentante Legale registrato in Area Clienti</h4>
            <div class="iper-grid">
                <div class="iper-field">
                    <label class="iper-label">Nome</label>
                    <app-copy-field [value]="customer?.Name"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Cognome</label>
                    <app-copy-field [value]="customer?.Surname"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Codice fiscale</label>
                    <app-copy-field [value]="signatoryFiscalCode"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Nazione di nascita</label>
                    <app-copy-field [value]="birthCountry"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Comune di nascita</label>
                    <app-copy-field [value]="birthPlace"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Email</label>
                    <app-copy-field [value]="customerEmail"></app-copy-field>
                </div>
                <div class="iper-field iper-span-2">
                    <label class="iper-label"><span class="iper-req">*</span>Il firmatario è il rappresentante legale o un delegato?</label>
                    <app-copy-field [value]="signatoryRole"></app-copy-field>
                </div>
                <div class="iper-field iper-span-2">
                    <label class="iper-label"><span class="iper-req">*</span>Confermi di essere il rappresentante legale iscritto su Area Clienti e visualizzato in precedenza?</label>
                    <app-copy-field></app-copy-field>
                </div>
            </div>
        </section>

        <!-- Punto 2 -->
        <section class="iper-section" *ngFor="let asset of annexAssets; let i = index">
            <button type="button" class="iper-collapse" (click)="toggleAnnex(i)" [attr.aria-expanded]="isAnnexOpen(i)">
                <i class="fa" [ngClass]="isAnnexOpen(i) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                Allegato IV<span *ngIf="annexAssets.length > 1"> — bene {{ i + 1 }}</span>
            </button>
            <div class="iper-collapse-body" *ngIf="isAnnexOpen(i)">
                <div class="iper-grid">
                    <div class="iper-field">
                        <label class="iper-label">Codice Bene Allegato IV <i class="fa fa-info-circle iper-info"></i></label>
                        <app-copy-field></app-copy-field>
                    </div>
                    <div class="iper-field iper-span-2">
                        <label class="iper-label">Scelta categoria <i class="fa fa-info-circle iper-info"></i></label>
                        <app-copy-field></app-copy-field>
                    </div>
                    <div class="iper-field">
                        <label class="iper-label">Descrizione <i class="fa fa-info-circle iper-info"></i></label>
                        <app-copy-field [value]="asset.description"></app-copy-field>
                    </div>
                    <div class="iper-field">
                        <label class="iper-label">Quantità</label>
                        <app-copy-field></app-copy-field>
                    </div>
                    <div class="iper-field">
                        <label class="iper-label">Data di completamento</label>
                        <app-copy-field [value]="completionDate"></app-copy-field>
                        <p class="iper-note">{{ completionHint }}</p>
                    </div>
                    <div class="iper-field">
                        <label class="iper-label">Data di interconnessione ai sistemi aziendali</label>
                        <app-copy-field></app-copy-field>
                        <p class="iper-note">{{ interconnectionHint }}</p>
                    </div>
                    <div class="iper-field iper-span-2">
                        <label class="iper-label">Componente di un bene complesso</label>
                        <app-copy-field></app-copy-field>
                    </div>
                    <div class="iper-field iper-span-2">
                        <label class="iper-label">Descrizione componente del bene complesso <i class="fa fa-info-circle iper-info"></i></label>
                        <app-copy-field></app-copy-field>
                    </div>
                    <div class="iper-field">
                        <label class="iper-label">Costo di acquisizione <i class="fa fa-info-circle iper-info"></i></label>
                        <app-copy-field [value]="asset.costDisplay" [copyText]="asset.costCopy"></app-copy-field>
                    </div>
                    <div class="iper-field">
                        <label class="iper-label">Coefficiente di ammortamento [%] <i class="fa fa-info-circle iper-info"></i></label>
                        <app-copy-field [value]="asset.rate"></app-copy-field>
                    </div>
                </div>
            </div>
        </section>

        <section class="iper-section">
            <button type="button" class="iper-collapse" (click)="totalsIvOpen = !totalsIvOpen" [attr.aria-expanded]="totalsIvOpen">
                <i class="fa" [ngClass]="totalsIvOpen ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                TOTALI ALLEGATO IV
            </button>
            <div class="iper-collapse-body" *ngIf="totalsIvOpen">
                <div class="iper-field">
                    <label class="iper-label">Totale costi di acquisizione</label>
                    <app-copy-field [value]="annexTotalDisplay" [copyText]="annexTotalCopy"></app-copy-field>
                </div>
            </div>
        </section>

        <section class="iper-section">
            <button type="button" class="iper-collapse" (click)="totalsVOpen = !totalsVOpen" [attr.aria-expanded]="totalsVOpen">
                <i class="fa" [ngClass]="totalsVOpen ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                TOTALI ALLEGATO V
            </button>
            <div class="iper-collapse-body" *ngIf="totalsVOpen">
                <div class="iper-field">
                    <label class="iper-label">Totale costi di acquisizione</label>
                    <app-copy-field [value]="annexVTotalDisplay" [copyText]="annexVTotalCopy"></app-copy-field>
                </div>
            </div>
        </section>

        <!-- Punto 3 -->
        <section class="iper-section">
            <h3 class="iper-title">Rappresentante Legale dichiarato</h3>
            <div class="iper-grid">
                <div class="iper-field">
                    <label class="iper-label">Nome</label>
                    <app-copy-field [value]="customer?.Name"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Cognome</label>
                    <app-copy-field [value]="customer?.Surname"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Codice fiscale</label>
                    <app-copy-field [value]="signatoryFiscalCode"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Nazione di nascita</label>
                    <app-copy-field [value]="birthCountry"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>Data di nascita</label>
                    <app-copy-field [value]="date(customer?.BirthDate)"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Comune di nascita</label>
                    <app-copy-field [value]="birthPlace"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label">Email</label>
                    <app-copy-field [value]="customerEmail"></app-copy-field>
                </div>
            </div>
        </section>

        <!-- Punto 4 -->
        <section class="iper-section">
            <h3 class="iper-title">Dati struttura produttiva</h3>
            <h4 class="iper-subtitle">Anagrafica</h4>
            <div class="iper-grid">
                <div class="iper-field">
                    <label class="iper-label">Denominazione sede</label>
                    <app-copy-field></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>Indirizzo</label>
                    <app-copy-field [value]="request?.OperationalHeadquartersAddress"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>Civico</label>
                    <app-copy-field [value]="request?.OperationalHeadquartersHouseNumber"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>CAP</label>
                    <app-copy-field></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>Regione</label>
                    <app-copy-field [value]="productionRegion"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>Provincia</label>
                    <app-copy-field [value]="request?.OperationalHeadquartersProvince"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>Comune</label>
                    <app-copy-field [value]="request?.OperationalHeadquarters"></app-copy-field>
                </div>
            </div>

            <h4 class="iper-subtitle">Dati catastali</h4>
            <div class="iper-grid">
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>Codice catastale del Comune</label>
                    <app-copy-field [value]="request?.TaxCredit5CadastralCode"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>Sezione <i class="fa fa-info-circle iper-info"></i></label>
                    <app-copy-field [value]="request?.TaxCredit5CadastralSection"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>Foglio</label>
                    <app-copy-field [value]="request?.TaxCredit5CadastralSheet"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>Particella prevalente</label>
                    <app-copy-field [value]="request?.TaxCredit5CadastralParticle"></app-copy-field>
                </div>
                <div class="iper-field">
                    <label class="iper-label"><span class="iper-req">*</span>Sub prevalente <i class="fa fa-info-circle iper-info"></i></label>
                    <app-copy-field [value]="request?.TaxCredit5CadastralSub"></app-copy-field>
                </div>
            </div>
        </section>
    </div>
</div>
